export default __webpack_public_path__ + "static/media/dispatch.c6d8c16e.svg";